module.exports = __webpack_public_path__ + "img/Dominican Republic.6a13b3fa.svg";